import { VOutlineIcon } from '@carboncopyco/icons';
import { DropdownMenuItem } from '@radix-ui/react-dropdown-menu';
import classNames from 'classnames';
import { TooltipBubble } from '../../TooltipBubble';
import { TextBase } from '../../Typography';
import type { DropdownFilterItemContent } from '../types';

type DropdownFilterItemProps<T extends string> =
  DropdownFilterItemContent<T> & {
    onSelect: (value: T) => void;
    isSelected: boolean;
  };
export function DropdownFilterItem<T extends string>({
  id,
  label,
  icon,
  disabled,
  onSelect,
  isSelected,
}: DropdownFilterItemProps<T>) {
  return (
    <TooltipBubble
      placement="top"
      title={label}
    >
      <label>
        <DropdownMenuItem
          textValue={label}
          disabled={disabled}
          onSelect={() => onSelect(id)}
          className={classNames(
            'px-2 h-9 flex justify-between focus:bg-ds-natural-50 items-center w-full gap-2 focus:outline-none rounded-md',
            {
              'cursor-pointer': !disabled,
              'text-ds-natural-200 cursor-default': disabled,
            }
          )}
        >
          {icon}
          <TextBase
            color={disabled ? 'text-ds-natural-200' : 'text-ds-natural-600'}
            label={label}
            ellipsis
          />
          {isSelected && (
            <div className="shrink-0">
              <VOutlineIcon />
            </div>
          )}
        </DropdownMenuItem>
      </label>
    </TooltipBubble>
  );
}
